import {css} from '@yandex-delivery/blocks/theme/css'
import {theme} from '@yandex-delivery/blocks/theme/theme'

import darkLogoSrc from './assets/YandexDeliveryRuDarkLogo.svg'
import type {Variant} from './types'

const variant: Record<`variant_${Variant}`, string> = {
  variant_postcard: css`
    ${theme.breakpoints.down('sm')} {
      display: none;
    }
  `,
}

export const classes = {
  root: css`
    justify-content: space-between;
    position: fixed;
    top: ${theme.spacing(2)}px;
    right: ${theme.spacing(2)}px;
    left: ${theme.spacing(2)}px;
    inline-size: auto;
    padding: ${theme.spacing(1)}px;
    padding-inline-start: ${theme.spacing(2)}px;
    background-color: ${theme.go.schemes.colors.system.BgMain};
    box-shadow: 0 8px 20px rgba(117, 115, 111, 0.2);
    border-radius: 24px;
    min-block-size: 56px;

    ${theme.breakpoints.down('sm')} {
      padding: 0;
      padding-inline-start: 0;
      min-block-size: auto;
      justify-content: center;
      background-color: transparent;
      box-shadow: none;
    }

    html[data-theme='dark'] & {
      background-color: #302f2d;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);

      ${theme.breakpoints.down('sm')} {
        background-color: transparent;
        box-shadow: none;
      }
    }
  `,
  button: css`
    ${theme.breakpoints.down('sm')} {
      display: none !important;
    }

    /* Тёмная тема: дневной цвет текста кнопки (#21201F) сливается с тёмной карточкой. */
    html[data-theme='dark'] & {
      color: #e0deda !important;
    }
  `,
  // Тёмный логотип: рендерится отдельным элементом (см. Header), а не CSS-подменой
  // фона блочного класса — в prod-сборке имена классов минифицируются, и селектор
  // вида [class*='brand_yandex'] перестаёт матчить (текст «Доставка» оставался
  // тёмным). Тот же ассет с коробочкой и размер, что у дневного brand_yandex.
  logoDark: css`
    display: inline-block;
    width: 162px;
    height: 32px;
    background: center / contain no-repeat url(${darkLogoSrc});
  `,
  ...variant,
}

export const additionalClasses = {
  isYandexIntegration: css`
    ${theme.breakpoints.up('sm')} {
      .${classes.root}& {
        right: unset;
        background-color: transparent;
        box-shadow: unset;
      }
    }
  `,
}
